import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router'
import { x } from '@xstyled/styled-components'

import Articles from '../components/Articles'
import { fetchArticles, fetchMoreArticles } from '../../store/articles'
import { sectionPageView, setPageType } from '../../store/app'
import { getVisitorId, getSessionId } from '../../store/article'
import { fetchAuthor } from '../../store/author'
import WingBanners from '../components/WingBanners'
import Ad from '../components/Ad'
import { FORMATS, MAPPINGS } from '../components/AdFormats'
import { AuthorPageSkeleton as Skeleton } from '../components/Skeletons'
import ArticleDeck from '../../templates/ArticleDeck'
import FollowConcept from '../components/FollowConcept'
import NotFound from './NotFound'
import Image from '../components/ui/Image'
import NoImage from '../../../assets/images/general/no-profile.png'

import aFB from '../../../assets/images/social-media/facebook-author.svg'
// import aT from '../../../assets/images/social-media/twitter-author.svg'
import aLI from '../../../assets/images/social-media/linkedin-author.svg'
import aI from '../../../assets/images/social-media/instagram-author.svg'

const DefaultTemplate = ({ articles, section, noImage, isConnected, sectionLabel, moreButton, withReadCount, adPath, author, isSubscribed }) => (
  <>
    <x.div maxWidth={1220} w='100%' mx='auto' mt={50}>
      <ArticleDeck articles={articles} section={section} noImage={noImage} moreButton={moreButton} isConnected={isConnected} withReadCount={withReadCount} adPath={adPath} />
    </x.div>
  </>
)

export class AuthorSectionPage extends (React.Component) {
  constructor (props) {
    super(props)
    props.fetchAuthor(props.authorSlug)
    props.sectionPageView(props.location.pathname, props.section, props.visitorId, props.sessionId, props.app.firstRender)
  }

  componentDidUpdate (prevProps) {
    if (!this.props.hasError || prevProps.authorSlug !== this.props.authorSlug) {
      if (!this.props.authorSlug || prevProps.authorSlug !== this.props.authorSlug) {
        this.props.fetchAuthor(this.props.authorSlug)
      }
    }
  }

  render () {
    const props = this.props
    const author = this.props.author
    const Template = props.template || DefaultTemplate
    setPageType('section')
    return (
      <>
        <x.main px={{ sm: '20px', wAdD: props.app.wallpaperActive ? '0px' : '200px' }} mt={{ sm: '96px', lg: props.app.wallpaperActive ? '0px' : '173px' }} w='100%' maxWidth={{ sm: '1260px', wAdD: props.app.wallpaperActive ? '1220px' : '1660px' }} mx='auto'>
          <Ad isConnected={props.isConnected} adPath={props.adPath} slotId='interstitial' targeting={{ interstitial: 'interstitial' }} collapseEmptyDiv className='advert' anchor='interstitial' mapping={MAPPINGS.Interstitial} {...FORMATS.interstitial} />
          <WingBanners isConnected={props.isConnected} adPath={props.adPath} location={props.location} author={props.author} onSlotRenderEndedLeft={props.onSlotRenderEndedLeft} onSlotRenderEndedRight={props.onSlotRenderEndedRight} />
          {author.author &&
            <>
              <x.div w='100%' maxWidth={700} mx='auto' my={50} borderWidth='0 0 1px 0' borderStyle='solid' borderColor='divider' textAlign='center'>
                <Image image={{ url: ((author.author.imageUrl && !author.author.imageUrl.match('undefined')) ? author.author.imageUrl : '') }} width={240} shape='square' noImage={NoImage} mx='auto' mb={30} borderRadius='100%' w={{ sm: '50px', lg: '127px' }} h={{ sm: '50px', lg: '127px' }} />
                <x.h1 text='h1' fontFamily='"PT Serif", serif'>{author && author.author ? author.author.name : 'Author name'}</x.h1>
                <x.p mt={10} mb={30}>{author && author.author ? author.author.description : 'Author Description'}</x.p>
                <x.div display='flex' justifyContent='center' spaceX={10} mx='auto' mb={20} className='author-follow'>
                  {author.author.relatedLinks?.facebook &&
                    <x.a target='_blank' rel='noopener noreferrer nofollow' href={author.author.relatedLinks?.facebook}><x.img src={aFB} alt={`Follow ${author.author.name} on Facebook`} /></x.a>}
                  {/* {author.author.relatedLinks?.twitter &&
                    <x.a target='_blank' rel='noopener noreferrer nofollow' href={author.author.relatedLinks?.twitter}><x.img src={aT} alt={`Follow ${author.author.name} on Twitter`} /></x.a>
                  } */}
                  {author.author.relatedLinks?.linkedin &&
                    <x.a target='_blank' rel='noopener noreferrer nofollow' href={author.author.relatedLinks?.linkedin}><x.img src={aLI} alt={`Connect with ${author.author.name} on LinkedIn`} /></x.a>}
                  {author.author.relatedLinks?.instagram &&
                    <x.a target='_blank' rel='noopener noreferrer nofollow' href={author.author.relatedLinks?.instagram}><x.img src={aI} alt={`Follow ${author.author.name} on Instagram`} /></x.a>}
                </x.div>
                <FollowConcept
                  topic={{ topic: author.author.uuid, type: 'author', name: author.author.name }}
                  followText='Follow Me'
                  unFollowText='Unfollow Me'
                  visitorId={props.visitorId}
                  sessionId={props.sessionId}
                  section={'authors/' + props.authorSlug}
                />
              </x.div>
              <Articles
                {...props} noDiv isConnected loading={Skeleton} section={'authors/' + props.authorSlug} count={24} pageSize={16} withMore moreButtonColour='btn-red' noImage={NoImage} notFound={NotFound} component={Template}
              />
            </>}
          {!author.author && <Skeleton />}
          <x.div maxWidth={1220} w='100%' mx='auto' mt={20} mb={50} textAlign='center' display='flex' justifyContent='center' alignItems='center' flexDirection='column'>
            <Ad isConnected={props.isConnected} adPath={props.adPath} collapseEmptyDiv slotId='leaderboard-bot' targeting={{ leaderboard: 'bot' }} className='advert' mapping={MAPPINGS.Leaderboard} {...FORMATS.leaderboard} />
          </x.div>
        </x.main>
      </>
    )
  }
}

AuthorSectionPage.defaultProps = {
  component: DefaultTemplate,
  section: 'authors/lou-anne-daniels'
}
const mapDispatchToProps = (dispatch) => bindActionCreators({ fetchArticles, fetchMoreArticles, fetchAuthor, sectionPageView }, dispatch)

export default withRouter(connect((state) => ({ app: state.app, articles: state.articles, author: state.author, visitorId: getVisitorId(state), sessionId: getSessionId(state) }), mapDispatchToProps)(AuthorSectionPage))
